import * as React from 'react';
import { IFileFieldValue } from '../../../../types/file';
import * as styles from './styles.css';
import { FileView } from '../FileView';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors, DragEndEvent } from '@dnd-kit/core';
import { arrayMove, SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import { onChangeField } from '../../../../../../AreaParts/types';
import { EAreaPartsField } from '../../../../../../AreaParts/internal/enums';

export interface IFileListViewProps {
  list: IFileFieldValue[];
  onDelete(id: number): void;
  onRotate(id: number): void;
  onMove: onChangeField;
  content: React.ReactNode;
}

export const FileListView: React.FC<IFileListViewProps> = props => {
  const { list, onDelete, onRotate, onMove, content } = props;

  const [items, setItems] = React.useState(list);

  React.useEffect(() => {
    setItems(list);
  }, [list]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    const oldIndex = items.findIndex(({ id }) => id === active.id);
    const newIndex = items.findIndex(({ id }) => id === over?.id);

    setItems(items => arrayMove(items, oldIndex, newIndex));

    onMove(EAreaPartsField.Photos, arrayMove(items, oldIndex, newIndex));
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={['upload-block', ...items.map(({ id }) => id)]} strategy={rectSortingStrategy}>
        <div className={styles['container']}>
          {items.map(file => (
            <div key={file.id} className={styles['item']}>
              <FileView
                id={file.id}
                value={file}
                onDelete={() => onDelete(file.id)}
                onRotate={() => onRotate(file.id)}
              />
            </div>
          ))}
          {content}
        </div>
      </SortableContext>
    </DndContext>
  );
};
